const couponToastMsg = {
  /**
   *  [쿠폰 리스트] 쿠폰 리스트 요청하기
   */
  GET_COUPON_LIST_REQUEST_SUCCESS: '쿠폰 리스트 요청하기 성공',
  GET_COUPON_LIST_REQUEST_ERROR: '쿠폰 리스트 요청하기 실패',

  /**
   *  [쿠폰 리스트] 쿠폰 리스트 엑셀 다운로드 요청하기
   */
  GET_COUPON_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '쿠폰 리스트 엑셀 다운로드 요청하기 성공',
  GET_COUPON_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR: '쿠폰 리스트 엑셀 다운로드 요청하기 실패',

  /**
   *  [쿠폰 생성] 쿠폰 생성하기
   */
  INSERT_COUPON_REQUEST_SUCCESS: '쿠폰 생성하기 성공',
  INSERT_COUPON_REQUEST_ERROR: '쿠폰 생성하기 실패',

  /**
   *  [쿠폰 생성] 쿠폰 별 쿠폰 적용 가능 상품 아이템 리스트 요청하기
   */
  GET_COUPON_PRODUCT_ITEM_REQUEST_SUCCESS: '쿠폰 별 쿠폰 적용 가능 상품 아이템 리스트 요청하기 성공',
  GET_COUPON_PRODUCT_ITEM_REQUEST_ERROR: '쿠폰 별 쿠폰 적용 가능 상품 아이템 리스트 요청하기 실패',

  /**
   *  [쿠폰 생성] 쿠폰 별 쿠폰 적용 가능 브랜드 아이템 리스트 요청하기
   */
  GET_COUPON_BRAND_ITEM_REQUEST_SUCCESS: '쿠폰 별 쿠폰 적용 가능 브랜드 아이템 리스트 요청하기 성공',
  GET_COUPON_BRAND_ITEM_REQUEST_ERROR: '쿠폰 별 쿠폰 적용 가능 브랜드 아이템 리스트 요청하기 실패',

  /**
   *  [쿠폰 생성] 전체 상품 리스트 EXCEL 다운로드
   */
  GET_COUPON_PRODUCT_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '전체 상품 리스트 EXCEL 다운로드 성공',
  GET_COUPON_PRODUCT_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR: '전체 상품 리스트 EXCEL 다운로드 실패',

  /**
   *  [쿠폰 생성] 전체 브랜드 리스트 EXCEL 다운로드
   */
  GET_COUPON_BRAND_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '전체 브랜드 리스트 EXCEL 다운로드 성공',
  GET_COUPON_BRAND_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR: '전체 브랜드 리스트 EXCEL 다운로드 실패',

  /**
   *  [쿠폰 생성] 선택한 상품 리스트 EXCEL 다운로드
   */
  GET_SELECTED_COUPON_PRODUCT_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '선택 상품 리스트 EXCEL 다운로드 성공',
  GET_SELECTED_COUPON_PRODUCT_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR: '선택 상품 리스트 EXCEL 다운로드 실패',

  /**
   *  [쿠폰 생성] 선택한 브랜드 리스트 EXCEL 다운로드
   */
  GET_SELECTED_COUPON_BRAND_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '선택 브랜드 리스트 EXCEL 다운로드 성공',
  GET_SELECTED_COUPON_BRAND_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR: '선택 브랜드 리스트 EXCEL 다운로드 실패',

  /**
   *  [쿠폰 생성] 상품 리스트 EXCEL 업로드 유효성 체크
   */
  CHECK_VALID_COUPON_PRODUCT_ITEM_LIST_EXCEL_UPLOAD_REQUEST_SUCCESS: '상품 리스트 EXCEL 업로드 유효성 체크 성공',
  CHECK_VALID_COUPON_PRODUCT_ITEM_LIST_EXCEL_UPLOAD_REQUEST_ERROR: '상품 리스트 EXCEL 업로드 유효성 체크 실패',

  /**
   *  [쿠폰 생성] 브랜드 리스트 EXCEL 업로드 유효성 체크
   */
  CHECK_VALID_COUPON_BRAND_ITEM_LIST_EXCEL_UPLOAD_REQUEST_SUCCESS: '브랜드 리스트 EXCEL 업로드 유효성 체크 성공',
  CHECK_VALID_COUPON_BRAND_ITEM_LIST_EXCEL_UPLOAD_REQUEST_ERROR: '브랜드 리스트 EXCEL 업로드 유효성 체크 실패',

  /**
   *  [쿠폰 생성] 브랜드 리스트 EXCEL 업로드
   */
  SET_COUPON_BRAND_ITEM_LIST_EXCEL_UPLOAD_REQUEST_SUCCESS: '브랜드 리스트 EXCEL 업로드 성공',
  SET_COUPON_BRAND_ITEM_LIST_EXCEL_UPLOAD_REQUEST_ERROR: '브랜드 리스트 EXCEL 업로드 실패',

  /**
   *  [쿠폰 생성] 해당 브랜드에서 쿠폰 적용 가능 상품 리스트 가져오기
   */
  GET_COUPON_APPLY_AVAILABLE_PRODUCT_LIST_REQUEST_SUCCESS: '해당 브랜드에서 쿠폰 적용 가능 상품 리스트 가져오기 성공',
  GET_COUPON_APPLY_AVAILABLE_PRODUCT_LIST_REQUEST_ERROR: '해당 브랜드에서 쿠폰 적용 가능 상품 리스트 가져오기 실패',

  /**
   *   [쿠폰 상세] 쿠폰 정보 가져오기
   */
  GET_COUPON_INFO_REQUEST_SUCCESS: '쿠폰 정보 가져오기 성공',
  GET_COUPON_INFO_REQUEST_ERROR: '쿠폰 정보 가져오기 실패',

  /**
   *  [쿠폰 편집] 쿠폰 편집 요청하기
   */
  EDIT_COUPON_REQUEST_SUCCESS: '쿠폰 편집 요청하기 성공',
  EDIT_COUPON_REQUEST_ERROR: '쿠폰 편집 요청하기 실패',

  /**
   *  [쿠폰 상세] 쿠폰 상세 가져오기
   */
  GET_COUPON_DETAIL_REQUEST_SUCCESS: '쿠폰 상세 가져오기 성공',
  GET_COUPON_DETAIL_REQUEST_ERROR: '쿠폰 상세 가져오기 실패',

  /**
   *  [쿠폰 상세] 쿠폰 사용내역 리스트 요청하기
   */
  GET_COUPON_USAGE_HISTORY_LIST_REQUEST_SUCCESS: '쿠폰 사용내역 리스트 요청하기 성공',
  GET_COUPON_USAGE_HISTORY_LIST_REQUEST_ERROR: '쿠폰 사용내역 리스트 요청하기 실패',

  /**
   *  [쿠폰 상세] 쿠폰 사용내역 리스트 엑셀 다운로드 요청하기
   */
  GET_COUPON_USAGE_HISTORY_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '쿠폰 사용내역 리스트 엑셀 다운로드 요청하기 성공',
  GET_COUPON_USAGE_HISTORY_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR: '쿠폰 사용내역 리스트 엑셀 다운로드 요청하기 실패',

  /**
   *  [쿠폰 상세] 쿠폰 미사용내역 리스트 요청하기
   */
  GET_COUPON_UN_USAGE_HISTORY_LIST_REQUEST_SUCCESS: '쿠폰 미사용내역 리스트 요청하기 성공',
  GET_COUPON_UN_USAGE_HISTORY_LIST_REQUEST_ERROR: '쿠폰 미사용내역 리스트 요청하기 실패',

  /**
   *  [쿠폰 상세] 쿠폰 미사용내역 리스트 엑셀 다운로드 요청하기
   */
  GET_COUPON_UN_USAGE_HISTORY_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '쿠폰 미사용내역 리스트 엑셀 다운로드 요청하기 성공',
  GET_COUPON_UN_USAGE_HISTORY_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR: '쿠폰 미사용내역 리스트 엑셀 다운로드 요청하기 실패',

  /**
   *  [쿠폰 상세] 쿠폰별 쿠폰 적용 가능 상품 리스트 요청하기
   */
  GET_COUPON_PRODUCT_LINK_LIST_REQUEST_SUCCESS: '쿠폰별 쿠폰 적용 가능 상품 정보 가져오기 성공',
  GET_COUPON_PRODUCT_LINK_LIST_REQUEST_ERROR: '쿠폰별 쿠폰 적용 가능 상품 정보 가져오기 실패',

  /**
   *  [쿠폰 상세] 쿠폰별 쿠폰 적용 가능 브랜드 리스트 요청하기
   */
  GET_COUPON_BRAND_LINK_LIST_REQUEST_SUCCESS: '쿠폰별 쿠폰 적용 가능 브랜드 정보 가져오기 성공',
  GET_COUPON_BRAND_LINK_LIST_REQUEST_ERROR: '쿠폰별 쿠폰 적용 가능 브랜드 정보 가져오기 실패',

  /**
   *  [쿠폰 발급] 발급할 쿠폰 리스트 가져오기
   */
  GET_ISSUED_COUPON_LIST_REQUEST_SUCCESS: '발급할 쿠폰 리스트 요청하기 성공',
  GET_ISSUED_COUPON_LIST_REQUEST_ERROR: '발급할 쿠폰 리스트 요청하기 실패',

  /**
   *  [쿠폰 발급] 쿠폰 발급받을 유저 리스트 요청하기
   */
  GET_GENERATE_COUPON_USER_LIST_REQUEST_SUCCESS: '쿠폰 발급받을 유저 리스트 요청하기 성공',
  GET_GENERATE_COUPON_USER_LIST_REQUEST_ERROR: '쿠폰 발급받을 유저 리스트 요청하기 실패',

  /**
   *  [쿠폰 발급] 쿠폰 발급받을 유저 리스트 엑셀 다운로드 요청하기
   */
  GET_GENERATE_COUPON_USER_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '쿠폰 발급받을 유저 리스트 엑셀 다운로드 요청하기 성공',
  GET_GENERATE_COUPON_USER_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR: '쿠폰 발급받을 유저 리스트 엑셀 다운로드 요청하기 실패',

  /**
   *  [쿠폰 발급] 쿠폰 발급받을 유저 리스트 요청하기
   */
  GET_PREPARATION_GENERATE_COUPON_REQUEST_SUCCESS: '쿠폰 발급 준비 데이터 요청하기 성공',
  GET_PREPARATION_GENERATE_COUPON_REQUEST_ERROR: '쿠폰 발급 준비 데이터 요청하기 실패',

  /**
   *  [쿠폰 발급] 검색으로 선택한 쿠폰 리스트 요청하기
   */
  GET_SEARCH_COUPON_RESULT_REQUEST_SUCCESS: '검색으로 선택한 쿠폰 리스트 요청하기 성공',
  GET_SEARCH_COUPON_RESULT_REQUEST_ERROR: '검색으로 선택한 쿠폰 리스트 요청하기 실패',

  /**
   *  [쿠폰 발급] 엑셀 일괄 발급 유효성 체크요청하기
   */
  EXCEL_BULK_GENERATE_COUPON_CHECK_REQUEST_SUCCESS: '유효 체크 요청하기 성공',
  EXCEL_BULK_GENERATE_COUPON_CHECK_REQUEST_ERROR: '유효 체크 요청하기 실패',

  /**
   *  [쿠폰 발급 내역 리스트] 쿠폰 발급 내역 리스트 요청하기
   */
  GET_COUPON_ISSUE_HISTORY_LIST_REQUEST_SUCCESS: '쿠폰 발급 내역 리스트 요청하기 성공',
  GET_COUPON_ISSUE_HISTORY_LIST_REQUEST_ERROR: '쿠폰 발급 내역 리스트 요청하기 실패',

  /**
   *  [쿠폰 발급 내역 상세] 쿠폰 발급 내역 상세 요청하기
   */
  GET_COUPON_ISSUE_HISTORY_DETAIL_REQUEST_SUCCESS: '쿠폰 발급 내역 상세 요청하기 성공',
  GET_COUPON_ISSUE_HISTORY_DETAIL_REQUEST_ERROR: '쿠폰 발급 내역 상세 요청하기 실패',

  /**
   *  [쿠폰 발급 내역 상세] 쿠폰 발급 리스트 요청하기
   */
  GET_COUPON_ISSUE_HISTORY_COUPON_GENERATED_LIST_REQUEST_SUCCESS:
    '쿠폰 발급 내역에 연결 할 쿠폰 발급 리스트 요청하기 성공',
  GET_COUPON_ISSUE_HISTORY_COUPON_GENERATED_LIST_REQUEST_ERROR:
    '쿠폰 발급 내역에 연결 할 쿠폰 발급 리스트 요청하기 실패',
};

export default couponToastMsg;
